// Registers the PWA service worker at app startup (production only).
// Called once from index.tsx — safe on browsers without service-worker support.

export function registerPwa(): void {
  if (process.env.NODE_ENV !== 'production') return;
  if (!('serviceWorker' in navigator)) return;
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/service-worker.js', { scope: '/' })
      .catch(() => {
        // Silent: no service worker just means no offline caching.
      });
  });
}
